
import ReferenceSection from './ReferenceSection';

const ReferenceContainer = ({
  references = [],
  register,
  control,
  errors,
}) => {
  return references
    .filter(({ reference }) => Boolean(reference))
    .map(({ reference, position, optional }, index) => (
      <ReferenceSection
        key={`reference-${position}`}
        referenceData={reference}
        position={position}
        index={index}
        optional={optional}
        register={register}
        control={control}
        errors={errors}
      />
    ));
};

export default ReferenceContainer;
